<footer>
  <span class="left">
    <a class="link" href="https://www.ecowaste.ch" target="_blank">&copy; EcoWaste SA {{today.getFullYear()}}</a>
  </span>
  <span *ngIf="session | async as session">{{session.client.name}}</span>
  <span class="right">
    <img class="sms" src="../../../assets/sms.png" alt="Swiss Made Software" height="23" width="136">
  </span>
</footer>
